var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider",style:({
                '--bg': _vm.bg,
                '--border-color': _vm.borderColor,
                '--thumb-color': _vm.thumbColor,
                '--height': _vm.height,
            })},[(_vm.label)?_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',[_c('input',{ref:"slider",attrs:{"type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"change":_vm.updateValue}})]),(_vm.error)?_c('span',{staticClass:"has-error animated headShake"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }